/* START - Shopify Inbox Chat */
const interval = setInterval(() => {
  const widget = document.querySelector('inbox-online-store-chat');
  // Wait for the widget "Shopify Inbox" to load
  if (!widget || !widget.shadowRoot) return;

  // Get the shadow root
  const shadow = widget.shadowRoot;

  // Check if the button exists
  const button = shadow.querySelector('button.chat-toggle');
  if (button) {
    if (!shadow.querySelector('#custom-style')) {

      // Apply custom styles to the shadow root
      const style = document.createElement('style');
      style.id = 'custom-style';
      style.textContent = `
        :host {
          display: none !important;
          opacity: 0;
          transition: opacity 0.3s ease-in-out 0.2s !important;
        }
        :host(.show) {
          display: block !important;
          opacity: 1;
        }
        button.chat-toggle {
          position: relative;
          width: 48px !important;
          height: 48px !important;
          margin: 0 !important;
          margin-top: 17px !important;
        }
        button.chat-toggle svg {
          height: 35px !important;
        }
        @media (min-width: 768px) {
          :host {
            right: calc(3.2rem + 48px) !important;
            bottom: calc(var(--mobile-sticky-bar-height, 0px) + var(--sticky-atc-bar-height, 0px) + 1.6rem) !important;
          }
        }
      `;
      shadow.appendChild(style);
      //console.log('Stili chat applicati!');
      widget.classList.add('show');

      const shopifyChat = document.getElementById("shopify-chat"); 

      if (shopifyChat) {
        const syncState = () => {
          if (widget.getAttribute("is-open") === "true") {
            shopifyChat.classList.add("is-open");
          } else {
            shopifyChat.classList.remove("is-open");
          }
        };

        // inizializza stato
        syncState();

        // osserva i cambiamenti dell'attributo
        const observer = new MutationObserver(syncState);
        observer.observe(widget, { attributes: true, attributeFilter: ["is-open"] });
      }
    }
    clearInterval(interval);
  }
}, 200);
/* END - Shopify Inbox Chat */